import { useState, useEffect } from 'react';

export function useCountUp(end, duration = 2000, isActive = false, from = 0) {
  const [count, setCount] = useState(from);

  useEffect(() => {
    if (!isActive) return;
    let rafId;
    const range = end - from;
    // Delay de 300ms antes de iniciar la animación
    const delayTimer = setTimeout(() => {
      let startTime = null;
      const animate = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        // easeOutCubic para suavidad
        const eased = 1 - Math.pow(1 - progress, 3);
        setCount(Math.floor(from + eased * range));
        if (progress < 1) {
          rafId = requestAnimationFrame(animate);
        } else {
          setCount(end);
        }
      };
      rafId = requestAnimationFrame(animate);
    }, 300);
    return () => { clearTimeout(delayTimer); cancelAnimationFrame(rafId); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive, end, duration, from]);

  return count;
}
